module.exports = __webpack_public_path__ + "static/media/manageWhite.ea2dd9c3.svg";